import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid'
import listPlugin from '@fullcalendar/list';
import momentTimezonePlugin from '@fullcalendar/moment-timezone';
import luxon2Plugin from '@fullcalendar/luxon2';
import moment from 'moment-timezone';
import 'moment-timezone/builds/moment-timezone-with-data-1970-2030';

document.addEventListener('DOMContentLoaded', function() {
  var calendarEl = document.getElementById('calendar');

  var start_date= $('meta[name="start_date"]').attr('content')
  var end_date= $('meta[name="end_date"]').attr('content')
  var gathering_id = $('meta[name="gathering_id"]').attr('content')
  var timeZoneSelectorEl = document.getElementById('time-zone-selector');

  let prevent_start_date = moment(start_date).tz("America/Denver").add(1, 'hours').format('YYYY-MM-DD hh:mm:ss');
  let prevent_end_date = moment(end_date).tz("America/Denver").subtract(90, 'minutes').format('YYYY-MM-DD hh:mm:ss');

  var calendar = new Calendar(calendarEl, {
    plugins: [ dayGridPlugin, timeGridPlugin, listPlugin, momentTimezonePlugin, luxon2Plugin ],
    allDaySlot: false,
    expandRows: true,
    editable: false,
    displayEventTime: false,
    slotMinTime: '00:00:00',
    height: 'auto',
    headerToolbar: {
      left: 'title',
      center: 'timeGridWeek,timeGridDay',
      right: 'prev,next'
    },
    initialView: 'timeGrid',
    titleFormat: { year: 'numeric', month: 'long' },
    timeZone: 'America/Denver',
    visibleRange: {
      start: start_date,
      end: end_date
    },
    validRange: {
      start: start_date,
      end: end_date
    },
    weekends: true,
    eventSources: [
      {
        url: '/api/v1/gathering-sessions/' + gathering_id + '.json'
      }
    ],
    events: [
      {
        start: prevent_start_date,
        end: prevent_end_date,
        display: 'inverse-background'
      }
    ]
  });

  calendar.render();

  timeZoneSelectorEl.addEventListener('change', function() {
    calendar.setOption('timeZone', this.value);
  });
});
